import React, { useState, useEffect, useCallback } from 'react'
import MapFilter from '../components/home/GoogleMaps/MapFilter'
import styled from 'styled-components';
import DeviceList from '../components/home/DeviceComponents/DeviceList';
import { getDeviceList } from '../api/getDeviceList';
import { download_exported_data } from '../api/downloadExportedData';
import { ToastContainer, toast } from 'react-toastify';
import { showConfirmToast } from '../components/home/DeviceComponents/ConfirmToast';




import DeviceDescription from '../components/home/DeviceComponents/DeviceDescription';
import DeviceActions from '../components/home/DeviceComponents/DeviceActions';
import Graph from '../components/home/DashboardComponents/Graph';
import DeviceEvents from '../components/home/DeviceComponents/DeviceEvents';

import { IoMdArrowRoundBack } from "react-icons/io";
import { getDeviceDetails } from '../api/getDeviceDetails';
import { updateClientInfo } from '../api/updateClientInfo';
import DatePickerEvent from '../components/home/DeviceComponents/DatePickerEvent';
import dayjs from 'dayjs';

function DevicesPage() {

    const user = JSON.parse(localStorage.getItem("user"));
    const [devicesData, setDevicesData] = useState([])
    const [totalDevices, setTotalDevices] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [isLoading, setIsLoading] = useState(false)
    const [filter, setFilter] = useState('all')


    const [chartWidth, setChartWidth] = useState(1400)
    const [chartHeight, setChartHeight] = useState(300)
    const [selectedDevice, setSelectedDevice] = useState({
        selected: false,
        device: ''
    })


    const [deviceData, setDeviceData] = useState({
        device: null,
        graphData: {
            daily: {
                data: [],
                labels: []
            },
            daily_reported: [],
            monthly: {
                data: [],
                labels: []
            },
            total: 0
        }
    })


    const [powerStatus, setPowerStatus] = useState(0)
    const [Date, setDate] = useState(dayjs());
    const [checkboxState, setCheckBoxState] = useState(false);

    const fetchDevices = useCallback(async (page, limit) => {
        setIsLoading(true)
        const offset = (page - 1) * limit
        try {
            const response = await getDeviceList(user.id, user.token, limit, offset, filter)

            if (response.error) {
                console.log('Error: ', response.message || response.status_code || "Unknown error");
                if (response.status_code === 401) {
                    localStorage.removeItem("user");
                    window.location.href = "/login";
                }
                return;
            }

            const data = response.data

            setTotalDevices(data.total)

            let devices = [];
            for (const device of data.data) {
                const client_info = device.client_info ? JSON.parse(device.client_info) : null;
                devices.push({
                    ...device,
                    client_info
                })
            }
            setDevicesData(devices)
        } catch (e) {
            console.log('Error: ', e)
        } finally {
            setIsLoading(false)
        }
    }, [user?.token, user?.id, filter])

    useEffect(() => {
        setChartWidth(Math.round(window.innerWidth * .85782));
        setChartHeight(Math.round(window.innerHeight * 0.37));
        //console.log('Chart dimensions: ', chartWidth, chartHeight);
        if (itemsPerPage > 0) {
            fetchDevices(currentPage, itemsPerPage)
        }
    }, [currentPage, itemsPerPage, fetchDevices])

    useEffect(() => {
        setCurrentPage(1)
    }, [filter])



    const handlePageChange = (page, newItemsPerPage) => {
        if (newItemsPerPage && newItemsPerPage !== itemsPerPage) {
            setItemsPerPage(newItemsPerPage)
            setCurrentPage(1)
        } else {
            const totalPages = Math.ceil(totalDevices / itemsPerPage) || 1
            if (page >= 1 && page <= totalPages) {
                setCurrentPage(page)
            }
        }
    }



    const [exportRunning, setExportRunning] = useState(false)

    async function download_excel(e) {

        if (exportRunning) return;
        setExportRunning(true);
        const confirmed = await showConfirmToast(
            `¿Desea exportar la última medición de todos los dispositivos?`
        );

        if (!confirmed) {
            toast.warning("Acción cancelada", {
                position: "top-center",
                autoClose: 1000,
                className: "!rounded-xl",
            })
            setExportRunning(false);
            return;
        }

        const fetch_excel = download_exported_data(user.id, user.token);

        try {
            await toast.promise(fetch_excel, {
                pending: "Solicitando datos...",
                success: {
                    render: "Datos solicitados",
                    autoClose: 2000
                },
                error: {
                    render: ({ data }) => data.message || "Error",
                    autoClose: 5000
                }
            });
        } catch (err) {
            console.error(err);
        }
        setExportRunning(false);
    }


    /////*********************************************************************************************************** */

    useEffect(() => {
        if(!Date || selectedDevice.selected === false)return;
        fetchDeviceDetails(user.token, user.id, selectedDevice.device.hwid, setDeviceData, setPowerStatus)
    }, [Date])

    const changeGraphDate = (d) => {
        if(d === null){
            return;
        }
        setDate(d);
        //console.log("Date:", d.format("YYYY-MM-DD"));
    }
    
    const fetchDeviceDetails = async (token, id, deviceHwid, setDeviceData, setPowerStatus) => {
        try {
            const response = await getDeviceDetails(deviceHwid, id, token, Date.format("YYYY-MM-DD"));
            if (response.error) {
                console.log('Error: ', response.message || response.status_code || "Unknown error");
                if (response.status_code === 401) {
                    localStorage.removeItem("user");
                    window.location.href = "/login";
                }
                return;
            }
            //console.log('Device details response: ', response.data);

            const data = response.data;
            const daily = parseConsumption(data.consumption.daily);
            const monthly = parseConsumption(data.consumption.monthly);
            const total = getTotalConsumption(data.consumption.monthly);
            const device = {
                ...data.device[0],
                client_info: JSON.parse(data.device[0].client_info)
            };
            //Setear valores
            setDeviceData({
                device: device,
                graphData: {
                    daily: daily,
                    daily_reported: data.consumption.daily_reported,
                    monthly: monthly,
                    total: total
                }
            })
            setPowerStatus(device?.power_enabled)

        } catch (e) {
            console.log('Error: ', e)
        }
    }


    const updateDeviceInfo = async (editClient, editAddress) => {
            
        const description = selectedDevice.device?.client_info;

        const client_info = {
            "lat": description.lat,
            "city": description.city,
            "long": description.long,
            "client": editClient,
            "address": editAddress
        }

        const updatePromise = updateClientInfo(selectedDevice.device.hwid, user.id, client_info, user.token);
        try {
            const response = await toast.promise(updatePromise, {
                pending: "Actualizando datos...",
                success: {
                    render: "Datos actualizados",
                    autoClose: 2000
                },
                error: {
                    render: ({ data }) => data.message || "Error",
                    autoClose: 5000
                }
            });

            if (response.error !== false) {
                throw new Error(response.message || "Error al actualizar datos");
            }
            
            setSelectedDevice(prev => ({
                ...prev,
                device: {
                    ...prev.device,
                    client_info: client_info
                }
            }));

            const index = devicesData.findIndex(
                device => device.hwid === selectedDevice.device.hwid
            )

            if (index !== -1) {
                devicesData[index].client_info = client_info;
            }

        } catch (err) {
            console.log('Error:', err)
        }
    };


    /////*********************************************************************************************************** */
    const handleDeviceSelect = (json) => {
        //console.log('Selected device: ', json);
        setSelectedDevice({ selected: json.selected, device: json.device });
        setCheckBoxState(false);
        setDate(dayjs())
        if (!json.selected) {
            return
        }
        //console.log('Setted device: ', json.device);
        fetchDeviceDetails(user.token, user.id, json.device.hwid, setDeviceData, setPowerStatus)
    }

    return (
        <DevicesListContainer>
            <ToastContainer
                position="top-center"
                hideProgressBar={false}
                newestOnTop={false}
                pauseOnHover={false}
                pauseOnFocusLoss={false}
                closeOnClick={false}
                rtl={false}
                theme="light"
            />
            <div className='selector-wrapper' style={{ display: selectedDevice.selected ? 'none' : 'flex' }}>
                <div className="filter-actions">
                    <MapFilter cleanFilter={true} setFilter={setFilter} exportEnabled={true} exportFunction={download_excel} />
                </div>
                <DeviceList
                    jsonData={devicesData}
                    handleDeviceSelect={handleDeviceSelect}
                    totalDevices={totalDevices}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    isLoading={isLoading}
                />
            </div>

            <div className='selector-wrapper' style={{ display: selectedDevice.selected ? 'flex' : 'none' }}>
                <DevicesDetailsContainer>
                    <button className='back' onClick={() => { handleDeviceSelect({ selected: false, device: '' }) }}>
                        <IoMdArrowRoundBack />
                        <p>Volver</p>
                    </button>
                    <div className='infoActions-wrapper'>
                        <div className='description'><DeviceDescription onEditHandler={updateDeviceInfo} meter_id={selectedDevice.device?.meter_id} description={selectedDevice.device?.client_info || {}} /></div>
                        <div className='actions'><DeviceActions className='actions' powerStatus={powerStatus} setDevicePowerStatus={setPowerStatus} total_consumption={deviceData?.graphData?.total} hwid={deviceData.device?.hwid} id={user.id} token={user.token} /></div>
                        <div className='date-picker'><DatePickerEvent date={Date} setDate={changeGraphDate} checkboxState={checkboxState} setCheckBoxState={setCheckBoxState}/></div>
                        
                    </div> 
                    <Graph graphData={deviceData?.graphData?.daily} reported={deviceData?.graphData?.daily_reported} width={chartWidth} height={chartHeight} />
                    <Graph graphData={deviceData?.graphData?.monthly} type='monthly' width={chartWidth} height={chartHeight} />
                    {/*<DeviceEvents jsonData={deviceEvent.jsonData} isLoading={false}/>*/}
                </DevicesDetailsContainer>
            </div>

        </DevicesListContainer>
    )
}


function parseConsumption(obj) {
    const data = [];
    const labels = [];

    Object.keys(obj)
        .sort((a, b) => Number(a) - Number(b))
        .forEach(key => {
            data.push((obj[key]) / 1000 || 0);
            labels.push(key.toString().padStart(2, "0"));
        });

    return { data, labels };
}

function getTotalConsumption(obj) {
    return Object.values(obj).reduce((acc, value) => acc + (Number(value) || 0), 0) / 1000;
}





const DevicesListContainer = styled.div`
  display: flex;
  height: auto;
  width: 100%;

  .selector-wrapper{
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 2%;
    height: 100%;
    width: 100%;
  }
  .filter-actions{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
  }
`;

const DevicesDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    width: 100%;
    height: auto;

    .back{
        background: #2858A2;
        color: #fff;
        border: none;
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        font-size: 16px;
        gap: 4px;
        padding: 5px;
        cursor: pointer;

        svg{
            display: block;
        }
    }

    .infoActions-wrapper{
        display: grid;
        width: 100%;
        grid-template-columns: 2fr 1fr;
        grid-template-rows: 1fr 0.3fr;
        grid-row-gap: 8px;

        .description{
            grid-area: 1 / 1 / 2 / 2;
        }

        .actions{
            grid-area: 1 / 2 / 2 / 3;
            display: flex;
            justify-content: end;
        }

        .date-picker{
            grid-area: 3 / 1 / 2 / 2;
        }
    }
`

export default DevicesPage
